import { useState } from "react";
import { Star } from "lucide-react";

const StarRating = ({
  rating = 0,
  totalStars = 5,
  onRatingChange,
  readOnly = false,
  width = "w-3.5",
  height = "h-3.5",
}) => {
  const [hover, setHover] = useState(0);

  const displayRating = hover || rating;

  const handleClick = (value) => {
    if (!readOnly && onRatingChange) {
      onRatingChange(value);
    }
  };

  return (
    <div className="flex space-x-1">
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = hover ? starValue <= hover : starValue <= rating;

        return (
          <Star
            key={index}
            className={`${width} ${height} transition ${
              isFilled ? "text-yellow-400" : "text-gray-300"
            } ${readOnly ? "cursor-default" : "cursor-pointer"}`}
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => setHover(starValue)}
            onMouseLeave={() => setHover(0)}
            fill={isFilled ? "currentColor" : "none"}
          />
        );
      })}
    </div>
  );
};

export default StarRating;
